<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaFeriados"
        title-table="Feriados"
        module="feriadoSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_FERIADO_INSERIR'"
        :view-permission="'ROLE_FERIADO_CONSULTAR'"
        :edit-permission="'ROLE_FERIADO_ATUALIZAR'"
        :delete-permission="'ROLE_FERIADO_DELETAR'"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormFeriado
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormFeriado from './forms/FormFeriado.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormFeriado,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('feriadoSettingsModule', {
      listaFeriados: state => state.listaFeriados,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Data',
          field: 'data',
          formatFn: this.formatDateGrid,
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('feriadoSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('feriadoSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
